import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import OrderAddonVpsComponent from "../../../components/Customer/cards/OrderAddonVpsComponent";

const OrderAddonVpsPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectHome = () => {
        navigate("/");
    }

    let redirect = (orderId) => {
        navigate('/don-dat-hang/' + orderId + '/chi-tiet-don-dat-hang.html');
    }

    return <OrderAddonVpsComponent
        vpsId={ params.vpsId }
        shouldRedirect={ (orderId) => redirect(orderId) }
        redirectHome={ () => redirectHome() }
    />;
}

export default OrderAddonVpsPage;